/** Normalize county labels for crosswalk ↔ population joins. */
export function normalizeCountyName(county: string | null | undefined): string {
  if (!county) return '';
  const c = county.trim().toLowerCase();
  return c.endsWith(' county') ? c.slice(0, -7).trim() : c;
}

export function countiesMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  return normalizeCountyName(a) === normalizeCountyName(b);
}
